<template>
    <v-layout wrap>
        <v-flex xs12 sm6>
            <v-select
      	v-model="selected"
        label="Labels"
      	chips
      	multiple
      	:items="labels"
      	item-text="name"
        color="primary"
        item-value="id"
        @input="(e)=>{$emit('input',associateLabels())}"
        @change="(e)=>{$emit('change',associateLabels())}"
        > 
        <template slot="selection" slot-scope="data">
          <v-chip
            :selected="data.selected"
            :disabled="data.disabled"
            :key="JSON.stringify(data.item)">
            <v-avatar class="primary white--text" left >{{ data.item.name.slice(0, 1).toUpperCase() }}</v-avatar>
            {{ data.item.name }}
          </v-chip>
        </template>
      </v-select>
        </v-flex>
        <v-flex xs12 sm4 offset-sm1 md3 lg3 offset-md1>
  	  <v-dialog v-model="dialog" max-width="400px">
        <template v-slot:activator="{ on }">        
          <v-btn class="mt-3" outlined color="primary" v-on="on">
            <v-icon class="mr-1">mdi-plus</v-icon>Add label
          </v-btn>
        </template>
	      <v-card>
	        <v-card-title>
	          <span class="headline">New label</span>
	        </v-card-title>
	        <v-card-text>
	            <v-layout wrap>
	              <v-flex xs12>
	                <v-text-field label="Name" v-model="newLabel.name" v-validate="'required|min:3|alpha_dash'" :error-messages="errors.collect('label')"
                		data-vv-name="label" required></v-text-field>
	              </v-flex>
	            </v-layout>
	          
	        </v-card-text>
	        <v-card-actions>
	          <v-spacer></v-spacer>
	          <v-btn text @click.native="close">Cancel</v-btn>
	          <v-btn @click.native="create">Save</v-btn>
	        </v-card-actions>
	      </v-card>
	    </v-dialog>
        </v-flex>
    </v-layout>
</template>
<script>
import HmdService from './../services/HmdService'
export default {
    props:{
        ids : {
          type:Boolean,
          required:false,
          default : false
        },
        value: {
            type : Array,
            required : true,
            default : []
        }
    },
    data(){return{
        labels:[],
        selected : [],
        newLabel : {
            name : ''
        },
        dialog:false
    }},
    methods:{
        associateLabels(){
            let t =this
            let labels = _.filter(t.labels,l=>{return t.selected.includes(l.id)})
            return this.ids?_.map(labels,'id'):labels 
        },
        getLabels(){
            HmdService.label_list().then(result => {
            this.labels = result.data
            })
        },
        close(){
            this.dialog=false
        },
        create(){
            let t =this
                this.$validator.validateAll()
          .then((result) => {
          	if (result){
            HmdService.label_create(t.newLabel.name, t)
              .then(result => {
                t.newLabel.name = ""
                t.labels.unshift(result.data)
                t.close()
              }).catch(function (error) {
                t.$store.commit('push', {msg: error, color: 'error'});
              });
              }})
        }
    },
    computed:{},
    mounted(){
        this.selected = _.map(this.value,v=>{return v.id})
        this.getLabels()
    }
}
</script>

